import React, { useState } from 'react';
import {
  Input,
  InputLabel,
  FormControl,
  Button,
  CircularProgress,
} from "@material-ui/core";

import { constants } from '../../../constants';

// Turn the Cloud Function's short error codes into something a teacher can act on.
function friendlyError(errMsg) {
  switch (errMsg) {
    case "invalid code":
      return "That access code isn't valid. Please check it and try again.";
    case "accessCode and uid required":
      return "Please enter your access code.";
    case "invalid user":
    case "There is no user record corresponding to the provided identifier.":
      return "We couldn't verify your account. Please sign out, sign in again and retry.";
    default:
      return "Something went wrong. Please try again.";
  }
}

function FirstTimeUserMsg({ user }) {
  const [accessCode, setAccessCode] = useState('');
  const [errMsg, setErrMsg] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [unlocked, setUnlocked] = useState(false);

  const onSubmit = ev => {
    // A real form submit: Enter works and no longer reloads the page.
    ev.preventDefault();
    const code = accessCode.trim();
    if (!code) {
      setErrMsg("Please enter your access code.");
      return;
    }
    if (!user || !user.uid) {
      setErrMsg(friendlyError("invalid user"));
      return;
    }
    setSubmitting(true);
    setErrMsg(null);
    fetch(`${constants.server}/access-code`, {
      method: 'POST',
      body: JSON.stringify({ accessCode: code, uid: user.uid })
    })
      .then(response => response.json())
      .then(response => {
        if (response && response.success) {
          // The dashboard switches to the session list as soon as the
          // subscription reaches the database listener.
          setUnlocked(true);
        } else {
          setErrMsg(friendlyError(response && response.errMsg));
          setSubmitting(false);
        }
      })
      .catch(() => {
        setErrMsg("Couldn't reach the server. Please check your internet connection and try again.");
        setSubmitting(false);
      });
  };

  return <div className='blk-cntr access-code-cntr'>
    <h1 style={{ fontSize: "1.5rem", fontWeight: 500 }}>Welcome!</h1>
    <p style={{ margin: "16px 0 24px", lineHeight: 1.4 }}>
      Enter the <strong>access code</strong> provided by your school to unlock your sessions.
    </p>
    {unlocked
      ? <div role="status" style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <CircularProgress size={24} /> <span>Code accepted. Loading your sessions…</span>
        </div>
      : <form onSubmit={onSubmit} noValidate>
          <FormControl fullWidth className="input-cntr">
            <InputLabel htmlFor="access-code">Access Code</InputLabel>
            <Input
              id="access-code"
              name="accessCode"
              type="text"
              autoComplete="off"
              autoCapitalize="characters"
              value={accessCode}
              onChange={ev => { setAccessCode(ev.target.value); }}
            />
          </FormControl>
          <div role="alert" style={{ color: "#BA1F00", minHeight: "1.4em", marginBottom: 8 }}>{errMsg}</div>
          <FormControl fullWidth className="input-cntr">
            <Button
              variant="raised"
              type="submit"
              disabled={submitting}
              classes={{ root: "action-btn-capsule", label: "btn-text" }}
            >
              <span style={{ color: "#FFF" }}>{submitting ? "Checking…" : "Unlock Sessions"}</span>
            </Button>
          </FormControl>
        </form>}
  </div>
}

export default FirstTimeUserMsg;
